import './App.css';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import MainRoutes from './routes/MainRoutes';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/redux/store';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Provider store={store}>
          <MainRoutes />
          {/* <ReactTooltip id="my-tooltip" style={{ borderRadius: 12, backgroundColor: 'white', color: 'gray' }} /> */}
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
